import * as ko from 'knockout'
import ObservableResultsPage from '../../../Model/Observables/ObservableResultsPage'
import { ResultsPageViewModel } from './ResultsPageViewModel'
import template from './results.tpl.html'

if (!ko.components.isRegistered('race-results')) {
  ko.components.register('race-results', {
    viewModel: {
      createViewModel: (params: { raceInformation: ObservableResultsPage }) => {
        const viewModel = new ResultsPageViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
